module.exports = __webpack_public_path__ + "static/img/mail.fd191b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/img/mail.png
// module id = 1UoY
// module chunks = 1